import "../styles/TourCard.css";

const tourCard = ({ image, title, date,info, onDetails }) => {
  return (
    <div className="tour-card">
      <div className="tour-image-wrapper">
        <img src={image} alt={title} />
      </div>

      <div className="tour-info">
        <h3>{title}</h3>
        <p>{date}</p>
        <p>{info}</p>

        <button className="details-btn" onClick={onDetails}>
          View Details
        </button>
      </div>
    </div>
  );
};

export default tourCard;
